import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getMrtApiBasepath} from '../ssr/helpers'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import fetch from 'cross-fetch'

export const fetchCustomProductSearch = async ({parameters, token, locale, site, origin}) => {
    const params = {...parameters}
    params.locale = locale?.id || locale
    params.site = site?.id || site
    params.page = 1
    params.limit = 200

    const headers = {
        authorization: token.startsWith('Bearer ') ? token : `Bearer ${token}`,
        'Content-Type': 'application/json',
    }

    const endpoint = origin + getMrtApiBasepath('/product-search')
    const response = await fetch(`${endpoint}`, {
        headers,
        method: 'POST',
        body: JSON.stringify(params),
    })
    const data = await response.json()

    if (!response.ok) {
        const error = new Error(data?.error || 'Failed to fetch custom product search')
        error.statusCode = response.status
        throw error
    }

    return data
}

export const useCustomProductSearch = ({parameters}, requestOptions) => {
    const {getTokenWhenReady} = useAccessToken()
    const {site, locale} = useMultiSite()
    const origin = useAppOrigin()

    return useQuery(
        [
            'getProductSearchCustom',
            parameters.urlSegment,
            JSON.stringify(parameters.searchParams),
            locale.id,
        ],
        async () => {
            const token = await getTokenWhenReady()
            return fetchCustomProductSearch({
                parameters,
                token,
                locale,
                site,
                origin,
            })
        },
        {
            ...requestOptions,
            suspense: typeof window === 'undefined',
        },
    )
}

export default useCustomProductSearch
